import {useState} from "react";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import "primeicons/primeicons.css";
import {API} from "./App";
import {getAuthHeader} from "./AuthRoute";

export default function GenerateExcelButton({projectName}) {
    const [loading, setLoading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [platform, setPlatform] = useState(null);

    const platforms = [
        {label: "Windows", value: "windows"},
        {label: "Mac", value: "mac"},
    ];

    const handleGenerate = async (mode) => {
        if (!platform) {
            alert("Please select your platform first.");
            return;
        }
        setShowDialog(false);
        setLoading(true);
        try {
            const endpoint =
                mode === "async"
                    ? `/projects/${projectName}/async-generate-excel?platform=${platform}`
                    : `/projects/${projectName}/generate-excel?platform=${platform}`;
            const res = await fetch(API() + endpoint, {
                headers: {Authorization: getAuthHeader()},
            });

            if (mode === "async") {
                if (res.status !== 202) throw new Error(res.status);
                window.open("/download-center", "_blank");
            } else {
                if (res.status !== 200) throw new Error(res.status);
                const blob = await res.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${projectName}_generated.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (err) {
            alert("Error: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                label="Generate Excel"
                icon="pi pi-cog"
                style={{margin: "10px"}}
                tooltip="Fill and download the Excel with interpretation data"
                loading={loading}
                onClick={() => setShowDialog(true)}
            />

            <Dialog
                header="Choose Generation Mode"
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                style={{width: "28rem"}}
            >
                <p>
                    The <b>platform</b> you select affects how spaces are handled in Excel files.
                    Choose correctly to avoid formatting issues.
                </p>

                <Dropdown
                    value={platform}
                    onChange={(e) => setPlatform(e.value)}
                    options={platforms}
                    placeholder="Select your platform"
                    className="w-full mt-3 mb-4"
                />

                <p className="mb-3">
                    <b>Normal generation:</b> immediate download, may timeout on large files.
                </p>
                <p>
                    <b>Async generation:</b> runs in background, view progress in the{" "}
                    <a
                        href="http://exomap-tool.terasol.ch/download-center"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Download Center
                    </a>.
                </p>

                <div className="flex justify-end gap-3 mt-4">
                    <Button label="Normal" icon="pi pi-download" onClick={() => handleGenerate("normal")}/>
                    <Button label="Async" icon="pi pi-clock" severity="success"
                            onClick={() => handleGenerate("async")}/>
                </div>
            </Dialog>
        </>
    );
}
